import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=266001b6&scoped=true&"
import script from "./downloadCenter.vue?vue&type=script&lang=js&"
export * from "./downloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./downloadCenter.vue?vue&type=style&index=0&id=266001b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266001b6",
  null
  
)

export default component.exports